export const dateFormat: any = {
    year: "numeric",
    month: "long",
    day: "numeric",
};